import { createSlice } from "@reduxjs/toolkit";

const initialUploadedDocsState = {
  docs: [],
  reqdocs: [],
  showSubmittedModal: false
};

const uploadedReqDocsSlice = createSlice({
  name: "uploadedReqDocs",
  initialState: initialUploadedDocsState,
  reducers: {
    setUploadedDocs(state, action) {
      state.docs = action.payload;
    },
    setRequestedDocs(state, action) {
      state.reqdocs = action.payload;
    },
    setShowSubmittedModal(state, action) {
      state.showSubmittedModal = action.payload;
    },
    resetUploadedDocs(state) {
      state.docs = [];
    },
    resetReqDocs(state) {
      state.reqdocs = [];
    },
  },
});

export const uploadedReqDocsActions = uploadedReqDocsSlice.actions;

export default uploadedReqDocsSlice.reducer;
